import { catchError } from './Error.action';
import {
  CLERK_QUICK_SEARCH_QUERY,
  CLERK_QUICK_SEARCH_RECEIVE,
  CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS,
  CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES,
  CLERK_QUICK_SEARCH_ERROR,
  CLERK_QUICK_SEARCH_SHOW_FULL_FORM,
  CLERK_QUICK_SEARCH_SELECT_ITEM,
} from '../constants';
import axios from 'axios';

let abortControllerPredicate;
let abortControllerSuggestions;
let abortControllerCategories;

export const queryPredicate = (q) => (dispatch, getState) => {
  if (q == null || !q.length || q.length < 3 || !window.__litium.clerk.isActive)
    return '';
  abortControllerPredicate && abortControllerPredicate.abort();
  abortControllerPredicate = new AbortController();
  return axios
    .post(
      window.__litium.clerk.apiUrlPredictive,
      {
        key: window.__litium.clerk.publicKey,
        query: decodeURIComponent(q),
        visitor: window.__litium.sessionId,
        limit: 10,
        labels: ["Search - Predictive"],
        attributes: ['id', 'local_article_number', 'name', "local_name", 'box_quantity', 'url', 'description'],
      },
      { cancelToken: abortControllerPredicate.token }
    )
    .then((response) => {
      dispatch(receive(response.data));
    })
    .catch((ex) => {
      if (axios.isCancel(ex)) {
        console.log('Request canceled', ex.message);
      } else {
        dispatch(catchError(ex, (error) => searchError(error)));
      }
    });
};

export const trackClick = (productId, path) => {

  console.log("track!");
  debugger;

  fetch('https://api.clerk.io/v2/log/click', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      key: window.__litium.clerk.publicKey,
      visitor: window.__litium.sessionId,
      product: productId,
      api: path,
      labels: ["Search - Predictive"]
    })
  });
}

export const querySuggestions = (q) => (dispatch, getState) => {
  if (q == null || !q.length || q.length < 3 || !window.__litium.clerk.isActive)
    return '';
  abortControllerSuggestions && abortControllerSuggestions.abort();
  abortControllerSuggestions = new AbortController();
  return axios
    .post(
      window.__litium.clerk.apiUrlSuggestions,
      {
        key: window.__litium.clerk.publicKey,
        visitor: window.__litium.sessionId,
        query: decodeURIComponent(q),
        labels: ["Search - Suggestions"],
        limit: 10,
      },
      { cancelToken: abortControllerSuggestions.token }
    )
    .then((response) => {
      dispatch(receiveSuggestions(response.data));
    })
    .catch((ex) => {
      if (axios.isCancel(ex)) {
        console.log('Request canceled', ex.message);
      } else {
        dispatch(catchError(ex, (error) => searchError(error)));
      }
    });
};

export const queryCategories = (q) => (dispatch, getState) => {
  if (q == null || !q.length || q.length < 3 || !window.__litium.clerk.isActive)
    return '';
  abortControllerCategories && abortControllerCategories.abort();
  abortControllerCategories = new AbortController();
  return axios
    .post(
      window.__litium.clerk.apiUrlCategories,
      {
        key: window.__litium.clerk.publicKey,
        visitor: window.__litium.sessionId,
        query: decodeURIComponent(q),
        labels: ["Search - Categories"],
        limit: 10,
      },
      { cancelToken: abortControllerCategories.token }
    )
    .then((response) => {
      dispatch(receiveCategories(response.data));
    })
    .catch((ex) => {
      if (axios.isCancel(ex)) {
        console.log('Request canceled', ex.message);
      } else {
        dispatch(catchError(ex, (error) => searchError(error)));
      }
    });
};

export const setSearchQuery = (query) => ({
  type: CLERK_QUICK_SEARCH_QUERY,
  payload: {
    query,
  },
});

export const searchError = (error) => ({
  type: CLERK_QUICK_SEARCH_ERROR,
  payload: {
    error,
  },
});

export const receive = (result) => ({
  type: CLERK_QUICK_SEARCH_RECEIVE,
  payload: {
    result,
    showResult: result && result.hits > 0,
    showFullForm: true,
  },
});

export const receiveSuggestions = (data) => ({
  type: CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS,
  payload: {
    suggestions: data.result,
  },
});

export const receiveCategories = (data) => ({
  type: CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES,
  payload: {
    categories: data.categories,
  },
});

export const hideFullForm = () => (dispatch) => {
  dispatch(show(false));
};

export const toggleShowFullForm = () => (dispatch, getState) => {
  dispatch(show(!getState().clerk.showFullForm));
};

const show = (visible) => ({
  type: CLERK_QUICK_SEARCH_SHOW_FULL_FORM,
  payload: {
    showFullForm: visible,
  },
});

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
  const { result, selectedItem } = getState().clerk;
  const keyCodeEscape = 27;
  const keyCodeTab = 9;
  const keyCodeUp = 38;
  const keyCodeDown = 40;
  const keyCodeEnter = 13;

  if (event.keyCode == keyCodeEscape) {
    dispatch(selectItem(-1));
    dispatch(hideFullForm());
  }
  if (!result || !result.result || !result.result.length) {
    return;
  }
  const max = result.result.length - 1,
    clip = (index) => (index < 0 ? max : index > max ? 0 : index);
  switch (event.keyCode) {
    case keyCodeTab:
      dispatch(selectItem(-1));
      break;
    case keyCodeUp:
      dispatch(selectItem(clip(selectedItem - 1)));
      break;
    case keyCodeDown:
      dispatch(selectItem(clip(selectedItem + 1)));
      break;
    case keyCodeEnter:
      const selectedObject = result.product_data[selectedItem];
      if (selectedObject && selectedObject.url) {
        location.href = selectedObject.url;
      } else {
        location.href = opt.searchUrl;
      }
      break;
    default:
      break;
  }
};

export const handleClickSearch = (opt) => (dispatch, getState) => {
  const { result } = getState().clerk;

  if (!result || !result.length) {
    return;
  }
  location.href = opt.searchUrl;
};

export const selectItem = (selectedItem) => ({
  type: CLERK_QUICK_SEARCH_SELECT_ITEM,
  payload: {
    selectedItem,
  },
});
